module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleted":"Deleted","draft":"New","rejected":"Rejected","published":"Published","showing":"showing","to":"to","of":"of","filters":"Filters","action":"Action","actor":"Actor","viewAction":"View Action","Text Search":"Text Search","Search":"Search","Free Text Searches":"Free Text Searches"}}')
  delete Component.options._Ctor
}
